import { BaseAnalysisEngine } from "../engines/baseAnalysisEngine";
import { AnalysisEngineType, isKnownAnalysisEngineType } from "../types";
import { useAtom } from "jotai";
import { engineAtomsMap } from "../store";
import { useParams } from "react-router-dom";

export function useAssertEngineTypeFromPathParam(): AnalysisEngineType {
  const { engineType } = useParams();
  if (!isKnownAnalysisEngineType(engineType))
    throw new Error("Internal Error! Invalid Engine Type");
  return engineType;
}

export function useGetAnalysisEngines(
  engineType: AnalysisEngineType,
): BaseAnalysisEngine<unknown>[] {
  const engineAtom = engineAtomsMap[engineType as keyof typeof engineAtomsMap];
  if (!engineAtom) {
    throw new Error(`${engineType} is not supported.`);
  }
  const [engines] = useAtom(engineAtom);
  return engines;
}
